import { useRBAC } from '@/hooks/useRBAC';
import { SuperAdminDashboard } from './SuperAdminDashboard';
import { SalesDashboard } from './SalesDashboard';
import { SalesCallDashboard } from '@/pages/calls/SalesCallDashboard';

export function DashboardPage() {
  const { role } = useRBAC();

  if (role === 'sales_executive') return <SalesCallDashboard />;
  if (role === 'doctor' || role === 'hospital') {
    return (
      <div className="text-center py-20 text-slate-500">
        <p>Appointment dashboard for {role}</p>
      </div>
    );
  }

  return <SuperAdminDashboard />;
}
